const BaseService = require('@/services/BaseService')

const namespace = 'chat-bots/questions'

const find = (id, options, cb, errorCb) => {
	BaseService.get(`${namespace}/${id}`, options, cb, errorCb)
}

const findAll = (options, cb, errorCb) => {
	BaseService.get(namespace, options, cb, errorCb)
}

const create = (options, cb, errorCb) => {
	BaseService.post(namespace, options, cb, errorCb)
}

const update = (id, options, cb, errorCb) => {
	BaseService.put(`${namespace}/${id}`, options, cb, errorCb)
}

const remove = (id, options, cb, errorCb) => {
	BaseService.remove(`${namespace}/${id}`, options, cb, errorCb)
}

export default {
	find,
	findAll,
	create,
	update,
	remove
}
